import { FontsContext } from './Fonts.context';

import { useFonts, useLoadFonts } from './Fonts.hooks';

export function Fonts({ children }: ChildrenProps) {
	const { fonts, isLoading, error } = useFonts();
	useLoadFonts(fonts);

	return (
		<FontsContext.Provider
			value={{
				isLoading,
				error,
				fonts,
			}}
		>
			{children}
		</FontsContext.Provider>
	);
}

interface ChildrenProps {
	children: string | JSX.Element | JSX.Element[];
}
